import { render, staticRenderFns } from "./FooterColumns.vue?vue&type=template&id=7ee6ab19"
import script from "./FooterColumns.vue?vue&type=script&lang=js"
export * from "./FooterColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserSession: require('/opt/build/repo/components/UserSession.vue').default,ScLangSwitcher: require('/opt/build/repo/node_modules/@evince/site/lib/packages/LangSwitcher.vue').default,FooterColumn: require('/opt/build/repo/components/layout/FooterColumn.vue').default,ScContactDetails: require('/opt/build/repo/node_modules/@evince/site/lib/packages/contact/Details.vue').default,ScSocialIcons: require('/opt/build/repo/node_modules/@evince/site/lib/packages/SocialIcons.vue').default,ScBusinessHours: require('/opt/build/repo/node_modules/@evince/site/lib/packages/BusinessHours.vue').default,ScDirectionsLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/DirectionsLink.vue').default,ScContactButton: require('/opt/build/repo/node_modules/@evince/site/lib/packages/contact/Button.vue').default})
